import { render, staticRenderFns } from "./DefaultFile.vue?vue&type=template&id=99ac7d32&"
import script from "./DefaultFile.vue?vue&type=script&lang=js&"
export * from "./DefaultFile.vue?vue&type=script&lang=js&"
import style0 from "./DefaultFile.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports